<template>
  <svg
    :class="svgClass"
    aria-hidden="true"
    v-on="$listeners"
    ref="icon"
    :style="iconStyle"
  >
    <defs v-if="shouldTint">
      <filter
        :id="filterId"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          :flood-color="color"
          result="tintColor"
        />
        <feComposite
          in="tintColor"
          in2="SourceAlpha"
          operator="in"
        />
      </filter>
    </defs>
    <use
      :xlink:href="iconName"
      :filter="colorFilter || undefined"
    />
  </svg>
</template>

<script>
import configColor from '@/config/color.config'
// 导入图标管理器
import iconManager from '@/utils/iconManager'

export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    size: {
      type: [Number, String],
      default: 16
    },
    color: {
      type: String,
      default: configColor.primaryColor
    },
    monochrome: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconStyle() {
      const style = {
        color: this.color
      }
      if (this.hasSizeProp) {
        style.fontSize = this.normalizedSize
      }
      return style
    },
    hasColorProp() {
      return Object.prototype.hasOwnProperty.call(
        this.$options.propsData || {},
        'color'
      )
    },
    hasSizeProp() {
      return Object.prototype.hasOwnProperty.call(
        this.$options.propsData || {},
        'size'
      )
    },
    normalizedSize() {
      if (typeof this.size === 'number') {
        return `${this.size}px`
      }
      const value = String(this.size).trim()
      return /^\d+(\.\d+)?$/.test(value)
        ? `${value}px`
        : value
    },
    filterId() {
      return `svg-icon-color-${this._uid}`
    },
    shouldTint() {
      return this.monochrome && this.hasColorProp
    },
    colorFilter() {
      return this.shouldTint
        ? `url(#${this.filterId})`
        : ''
    },
    // isExternal() {
    //   return isExternal(this.iconClass);
    // },
    iconName() {
      // 直接返回图标名称，不在此处进行异步加载
      return `#icon-${this.iconClass}`
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    },
    styleExternalIcon() {
      return {
        mask: `url(${this.iconClass}) no-repeat 50% 50%`,
        '-webkit-mask': `url(${this.iconClass}) no-repeat 50% 50%`
      }
    }
  },
  watch: {
    // 监听 iconClass 变化，自动加载对应图标
    iconClass: {
      handler(newIconClass) {
        if (newIconClass) {
          iconManager
            .loadIcon(newIconClass)
            .catch(error => {
              console.warn(
                `Failed to load icon: ${newIconClass}`,
                error
              )
            })
        }
      },
      immediate: true // 立即执行一次
    }
  }
}
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.svg-external-icon {
  background-color: currentColor;
  mask-size: cover !important;
  display: inline-block;
}
</style>
